export default function ConverterFeatures() {
  const features = [
    {
      icon: 'ri-file-transfer-line',
      title: '多格式支持',
      description: '支持 PDF 与 Word、Excel、PPT、图片等 20+ 种格式互转，满足各类文档转换需求'
    },
    {
      icon: 'ri-layout-masonry-line',
      title: '保持原始格式',
      description: '智能识别文档结构，精确保留字体、图片、表格、布局等所有元素'
    },
    {
      icon: 'ri-stack-line',
      title: '批量处理',
      description: '支持批量文档转换，大幅提升工作效率，节省人工处理时间'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'API 集成',
      description: '提供完整的 REST API，轻松集成到现有业务系统和工作流程'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠',
      description: '企业级安全保障，支持本地部署，确保文档数据安全和隐私保护'
    },
    {
      icon: 'ri-flashlight-line',
      title: '高速转换',
      description: '采用先进的转换引擎，处理速度快，大文件转换也能保持高效'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            强大的转换功能
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            专业的 PDF 转换工具，为您提供高质量、高效率的文档转换服务
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-8 bg-white border border-gray-200 rounded-xl hover:border-teal-500 hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}